module.exports = __webpack_public_path__ + "static/media/loader.d2b1f7a9.png";